var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTranslated = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DA6944",
    d: "M4.69 2.221 5 1.542l.678-.308L5 .925 4.691.246l-.31.68-.678.308.679.308zm-1.851.124L2.22.987l-.617 1.358-1.358.617 1.358.617.617 1.358.618-1.358 1.358-.617zM4.69 3.703l-.31.679-.678.309.679.308.309.68.308-.68.68-.308-.68-.31z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454BD1",
    d: "M11.103 2.965c-4.089 0-7.4 3.318-7.4 7.407s3.311 7.408 7.4 7.408c4.096 0 7.415-3.319 7.415-7.408s-3.319-7.407-7.415-7.407m5.134 4.444H14.05a11.6 11.6 0 0 0-1.022-2.637 5.95 5.95 0 0 1 3.207 2.637M11.11 4.476a10.4 10.4 0 0 1 1.414 2.933h-2.83c.32-1.059.8-2.044 1.415-2.933m-5.734 7.378a6 6 0 0 1-.192-1.482c0-.51.074-1.007.192-1.481h2.504c-.06.489-.104.978-.104 1.481s.045.993.104 1.482zm.608 1.481H8.17c.237.926.578 1.815 1.022 2.637a5.92 5.92 0 0 1-3.207-2.637M8.17 7.41H5.985a5.92 5.92 0 0 1 3.207-2.637A11.6 11.6 0 0 0 8.17 7.41m2.94 8.86a10.4 10.4 0 0 1-1.414-2.934h2.83c-.32 1.06-.8 2.045-1.415 2.933m1.734-4.415H9.377a11 11 0 0 1-.118-1.482c0-.503.052-1 .118-1.481h3.467c.067.481.118.978.118 1.481s-.051.993-.118 1.482m.185 4.118a11.6 11.6 0 0 0 1.022-2.637h2.185a5.95 5.95 0 0 1-3.207 2.637m1.311-4.118c.06-.49.104-.978.104-1.482 0-.503-.045-.992-.104-1.481h2.504c.118.474.192.97.192 1.481s-.074 1.008-.192 1.482z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h5.926v5.926H0z"
  })))));
};
export default SvgTranslated;